import { render, staticRenderFns } from "./editorBox.vue?vue&type=template&id=400f0a80&scoped=true&"
import script from "./editorBox.vue?vue&type=script&lang=js&"
export * from "./editorBox.vue?vue&type=script&lang=js&"
import style0 from "./editorBox.vue?vue&type=style&index=0&id=400f0a80&lang=less&scoped=true&"
import style1 from "./editorBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f0a80",
  null
  
)

export default component.exports